import React, { useState, useEffect } from 'react';
import { Box, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';



import MatchingHeader from './MatchingHeader';

import MenteePanel from './MenteePanel';
import { Campaign } from '../../../../types/Campaign';
import matchingService from '../../../../services/MatchingService';
import { MatchingOverviewData } from '../../../../types/Matching';

interface MatchingPanelProps {
    campaign: Campaign;
}

const MatchingPanel: React.FC<MatchingPanelProps> = ({ campaign }) => {
    const [overview, setOverview] = useState<MatchingOverviewData | null>(null);
    const [filter, setFilter] = useState<'all' | 'unmatched'>('all');
    useEffect(() => {
        matchingService.getMatchingOverview(campaign.organization_id, campaign.id).then((data) => {
            setOverview(data);
        });
    }, [campaign.organization_id, campaign.id]);

    return (
        <Box sx={{ p: 3, maxWidth: 900, mx: 'auto' }}>
            <MatchingHeader overview={overview} />

            {/* Filter Toggle */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <ToggleButtonGroup
                    value={filter}
                    exclusive
                    size="small"
                    onChange={(_e, val) => val && setFilter(val)}
                >
                    <ToggleButton value="all">All</ToggleButton>
                    <ToggleButton value="unmatched">Unmatched</ToggleButton>
                </ToggleButtonGroup>
            </Box>

            {overview ? (
                overview.mentees
                    .filter((m) => filter === 'all' || !m.matched)
                    .map((m) => (
                    <MenteePanel
                        key={`${m.first_name}-${m.last_name}`}
                        mentee={m}
                        onViewDetails={() => { /* TODO: hook up modal */ }}
                        onFinalizeMatch={() => { /* TODO: finalize match */ }}
                    />
                ))
            ) : (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    Loading sample matching data...
                </Typography>
            )}
        </Box>
    );
};

export default MatchingPanel;
